export const GET_EVENTS = "GET_EVENTS";
export const CREATE_EVENT = "CREATE_EVENT";
export const UPDATE_EVENT = "UPDATE_EVENT";
export const DELETE_EVENT = "DELETE_EVENT";
export const VIEW_EVENT = "VIEW_EVENT";
export const ACTION_LOADING_EVENT = "ACTION_LOADING_EVENT";
export const ACTION_COMPLETE_EVENT = "ACTION_COMPLETE_EVENT";
export const ACTION_FAILED_EVENT = "ACTION_FAILED_EVENT";
export const ACTION_RESET_EVENT = "ACTION_RESET_EVENT";
